<template>
  <div
    class="
      hidden
      md:block md:w-[240px]
      p-[24px]
      h-screen
      bg-[#1C6806]
      md:rounded md:mr-[20px]
    "
  >
    <button
      class="
        flex
        items-center
        w-full
        py-[15px]
        px-[8px]
        rounded
        hover:bg-green-700
        mb-[16px]
      "
    >
      <span class="mr-[16px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 6H12L10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM14 16H6V14H14V16ZM18 12H6V10H18V12Z"
            fill="#EDEDED"
          />
        </svg>
      </span>
      <h2 class="text-white text-[16px] leading-[16px] font-normal">
        Revenue Streams
      </h2>
    </button>

    <button
      class="
        flex
        items-center
        w-full
        py-[15px]
        px-[8px]
        rounded
        hover:bg-green-700
        mb-[16px]
      "
    >
      <span class="mr-[16px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 17C7.45 17 7 16.55 7 16V11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11V16C9 16.55 8.55 17 8 17ZM12 17C11.45 17 11 16.55 11 16V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V16C13 16.55 12.55 17 12 17ZM16 17C15.45 17 15 16.55 15 16V14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14V16C17 16.55 16.55 17 16 17Z"
            fill="white"
          />
        </svg>
      </span>
      <h2 class="text-white text-[16px] leading-[16px] font-normal">
        Assessments
      </h2>
    </button>

    <button
      class="
        flex
        items-center
        w-full
        py-[15px]
        px-[8px]
        rounded
        hover:bg-green-700
        mb-[16px]
      "
    >
      <span class="mr-[16px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M11.9991 5.00003V2.21003C11.9991 1.76003 11.4591 1.54003 11.1491 1.86003L7.34905 5.65003C7.14905 5.85003 7.14905 6.16003 7.34905 6.36003L11.1391 10.15C11.4591 10.46 11.9991 10.24 11.9991 9.79003V7.00003C15.7291 7.00003 18.6791 10.42 17.8591 14.29C17.3891 16.56 15.5491 18.39 13.2891 18.86C9.71905 19.61 6.53905 17.16 6.05905 13.85C5.98905 13.37 5.56905 13 5.07905 13C4.47905 13 3.99905 13.53 4.07905 14.13C4.69905 18.52 8.87905 21.77 13.6091 20.85C16.7291 20.24 19.2391 17.73 19.8491 14.61C20.8391 9.48003 16.9391 5.00003 11.9991 5.00003Z"
            fill="white"
          />
        </svg>
      </span>
      <h2 class="text-white text-[16px] leading-[16px] font-normal">
        Recurring Bills
      </h2>
    </button>
  </div>
</template>

<script>
export default {
    name: 'SideBar',

    data(){
        return{

        }
    }

}
</script>

<style>
</style>